"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createTemporaryDir = void 0;
const os = require("os");
const fs_1 = require("fs");
const path_1 = require("path");
const { mkdtemp } = fs_1.promises;
async function createTemporaryDir() {
    return await mkdtemp(path_1.join(os.tmpdir(), 'snyk'));
}
exports.createTemporaryDir = createTemporaryDir;
//# sourceMappingURL=fs.js.map